import React from "react";
import { RouteObject } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";

// Import all the page components (same as in router.tsx)
import { lazy } from "react";

const CallSMS = lazy(() => import("@/pages/call-sms/page"));
const CallSMSById = lazy(() => import("@/pages/call-sms/[id]/page"));
const CallSMSInbound = lazy(() => import("@/pages/call-sms/inbound/page"));
const CallSMSInboundById = lazy(() => import("@/pages/call-sms/inbound/[id]/page"));
const Chat = lazy(() => import("@/pages/(chat)/page"));
const ChatById = lazy(() => import("@/pages/(chat)/chat/[id]/page"));
const Browser = lazy(() => import("@/pages/browser/page"));
const BrowserById = lazy(() => import("@/pages/browser/[id]/page"));
const Scanner = lazy(() => import("@/pages/scanner/page"));
const ScannerById = lazy(() => import("@/pages/scanner/[id]/page"));
const PriorAuth = lazy(() => import("@/pages/prior-auth/page"));
const PriorAuthById = lazy(() => import("@/pages/prior-auth/[id]/page"));
const MedRec = lazy(() => import("@/pages/med-rec/page"));
const MedRecById = lazy(() => import("@/pages/med-rec/[id]/page"));

/**
 * Define the routes that should be available in embed mode
 * This is much cleaner than duplicating every route
 */
const embedableRoutes = [
  { path: "/call-sms", component: CallSMS },
  { path: "/call-sms/:id", component: CallSMSById },
  { path: "/call-sms/inbound", component: CallSMSInbound },
  { path: "/call-sms/inbound/:id", component: CallSMSInboundById },
];

/**
 * Generate embed routes automatically
 * This creates /embed/* versions of all the routes above
 */
export function generateEmbedRoutes(): RouteObject[] {
  return embedableRoutes.map(({ path, component }) => ({
    path: `/embed${path}`,
    element: React.createElement(ProtectedRoute, null, React.createElement(component, null)),
  }));
}

/**
 * Check if a route path is embeddable
 */
export function isEmbeddableRoute(path: string): boolean {
  const cleanPath = path.replace('/embed', '');
  return embedableRoutes.some(route => {
    // Simple check - could be more sophisticated with pattern matching
    return route.path === cleanPath || cleanPath.startsWith(route.path.replace(':id', ''));
  });
}
